<template>
    <div :class="['page refer',{ off: !pageOn }]">
        <VHeader type="back" @back="pageOn = false" />
        <div class="page-content" :style="{ backgroundColor: backgroundColor, color: infoFontColor }">
            <img style="width:100%" :src="referWords" />
            <div v-if="refer.href" @click="copyLink">
                <img class="refer-qr" :src="refer.qr" />
                <p class="refer-href" :style="{ color: infoFontColor, fontSize: '13px' }">{{ refer.href }}</p>
                <p class="btn" :style="{ backgroundColor: btnColor, color: btnFontColor }">COPY LINK</p>
            </div>

        </div> 
    </div>
</template>

<script>

import VHeader from '@/components/VHeader.vue'
import { pageOn } from '@/utils/pageOn.js'
import WebSoc from '@/utils/WebSoc.js'
import { mapActions, mapMutations } from 'vuex';

export default {
    name: 'refer',
    mixins: [ pageOn ],
    computed: {
        client_id () { return this.$store.state.client_id },
        backgroundColor () { return this.$store.state.backgroundColor },
        fontColor () { return this.$store.state.fontColor },
        btnFontColor () { return this.$store.state.btnFontColor },
        btnColor () { return this.$store.state.btnColor },
        infoFontColor () { return this.$store.state.infoFontColor },
        customer_id () { return this.$store.state.auth._id },
        referWords () { return this.$store.state.referWords },
        referCampaign_id () { return this.$store.state.referCampaign_id },
        referCampaignQty () { return this.$store.state.referCampaignQty }
    },
    data () {
        return {
            refer: {}
        }
    },
    components: {
        VHeader
    },
    mounted () {
        var { client_id, customer_id, referCampaignQty, referCampaign_id } = this;
        WebSoc.SEND({ t: 'getReferLink', data: { client_id, customer_id, referCampaignQty, referCampaign_id } },resp => {
            var refer = resp.refer;
            if ( !refer ) return console.log('!refer');
            refer.href = 'https://'+location.host+'/join-now/'+refer.id;
            refer.qr = 'https://api-v2.memberstar.club/qr?id='+encodeURIComponent(refer.href);
            this.refer = refer;
        });
    },
    methods: {
        copyLink () {
            var copyText = this.$el.querySelector('.refer-href')
            var selection = document.getSelection();
            var range = document.createRange();
                range.selectNode(copyText);
                selection.removeAllRanges();
                selection.addRange(range);
                if ( document.execCommand('copy') ) {
                    copyText.classList.add('copied');
                    setTimeout(() => {
                        copyText.classList.remove('copied')
                        selection.removeAllRanges();
                    },1000);
                    return true;
                } else {
                    return false;
                }            
        }
    }
}

</script>

<style lang="scss">
.refer-href {
    text-decoration: underline;
    text-align: center;
    position: relative !important;
    float: left;
    width: 100%;
    margin: 20px 0px !important;
    &.copied:after {
        content: 'copied';
        position: absolute;
        top: -33px;
        width: 100px;
        background-color: black;
        color: white;
        line-height: 30px;
        left: calc(50% - 50px);
    }
}
.refer-qr {
    width: 60%;
    margin-left: 20%;
    margin-bottom: 20px;
    float: left;
}
.refer .btn {
    float: left;
    margin-top: 25px !important;
    width: 80%;
}
</style>